
function SlideShowWords({ text }) {
    return (
        <div className="slideShowLine">
            {text} 
        </div>
    );
}

export default SlideShowWords;